const useDownloadCSV = () => {
  const handleDownload = ({
    data = [],
    headers = [],
    filename = "data.csv",
  }) => {
    // Convert data to CSV string
    const csvString = [[...headers], ...data]
      .map((e) => e.join(","))
      .join("\n");

    // Create a Blob from the CSV String
    const blob = new Blob([csvString], { type: "text/csv" });

    // Create a URL for the blob
    const url = URL.createObjectURL(blob);

    // Create a temporary anchor to trigger download
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return handleDownload;
};

export default useDownloadCSV;
